export default __webpack_public_path__ + "static/media/maindp.d4864fec.png";